/* ==========================================================================
   TRCO Cart Drawer — behaviour (native UpCart replacement)
   Travel Ring Co · Dawn theme
   ========================================================================== */
(function () {
  'use strict';

  var cfgEl = document.getElementById('trco-cart-config');
  if (!cfgEl) return;
  var CONFIG;
  try { CONFIG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function url(path) { return (ROOT + path).replace(/([^:]\/)\/+/g, '$1'); }

  /* ---- money ------------------------------------------------------------ */
  function formatMoney(cents, format) {
    format = format || CONFIG.moneyFormat || '${{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents2 = parts[1] ? decimal + parts[1] : '';
      return dollars + cents2;
    }
    var match = format.match(placeholder);
    if (!match) return format;
    var value;
    switch (match[1]) {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function sizedImg(src, size) {
    if (!src) return '';
    return src.replace(/(\.(?:jpg|jpeg|png|gif|webp))(\?|$)/i, '_' + size + 'x$1$2');
  }

  /* ---- ajax helpers ----------------------------------------------------- */
  function getJSON(path) {
    return fetch(url(path), { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }
  function postJSON(path, body) {
    return fetch(url(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  /* ==========================================================================
     Controller
     ========================================================================== */
  function Ctrl(el) {
    this.el = el;
    this.cart = null;
    this.compareCache = {};   // variantId -> compareAt cents
    this.productCache = {};   // handle -> product.js
    this.timerInterval = null;
    this._noteTimer = null;
    this._loading = false;
    this.upsellProducts = {};      // handle -> normalized product for display
    this._upsellMap = null;        // { default:[], byHandle:{} }
    this._upsellMapPromise = null;
    this._lastItemsHTML = null;    // last rendered line-items HTML (skip identical rewrites -> no flicker)
    this._lastUpsellHTML = null;   // last rendered upsell HTML
    this.init();
  }

  Ctrl.prototype.$ = function (sel) { return this.el.querySelector(sel); };

  Ctrl.prototype.init = function () {
    this.itemsEl = this.$('[data-trco-items]');
    this.upsellsEl = this.$('[data-trco-upsells]');
    this.upsellListEl = this.$('[data-trco-upsell-list]');
    this.emptyEl = this.$('[data-trco-empty]');
    this.footerEl = this.$('[data-trco-footer]');
    this.timerEl = this.$('[data-trco-timer]');
    this.timerTextEl = this.$('[data-trco-timer-text]');
    this.checkoutTextEl = this.$('[data-trco-checkout-text]');
    this.noteEl = this.$('[data-trco-note]');
    this.addonEl = this.$('[data-trco-addon]');
    this.addonToggle = this.$('[data-trco-addon-toggle]');
    this.discountInput = this.$('[data-trco-discount]');
    this.discountStatus = this.$('[data-trco-discount-status]');

    this.applyColors();
    this.applyCopy();
    this.bindStatic();
    this.refresh(false);   // prime state quietly
  };

  Ctrl.prototype.applyColors = function () {
    var c = CONFIG.colors || {};
    var map = {
      '--trco-bg': c.background, '--trco-accent': c.accent, '--trco-btn': c.button,
      '--trco-btn-text': c.buttonText, '--trco-text': c.text, '--trco-savings': c.savings,
      '--trco-timer-bar': c.timerBar, '--trco-timer-text': c.timerText
    };
    for (var k in map) { if (map[k]) this.el.style.setProperty(k, map[k]); }
  };

  Ctrl.prototype.applyCopy = function () {
    var copy = CONFIG.copy || {};
    var set = function (sel, txt) { var e = this.$(sel); if (e) e.textContent = txt || ''; }.bind(this);
    set('[data-trco-upsell-heading]', copy.upsellHeading);
    set('[data-trco-notes-toggle] span', copy.notesToggle);
    set('[data-trco-discount-apply]', copy.discountApply || 'Apply');
    set('[data-trco-empty-text]', copy.emptyCart);
    set('.trco-cart__continue', copy.continueShopping);
    if (this.noteEl) this.noteEl.placeholder = copy.notesPlaceholder || '';
    if (this.discountInput) this.discountInput.placeholder = copy.discountPlaceholder || '';

    var addon = CONFIG.addon || {};
    set('[data-trco-addon-title]', addon.title);
    set('[data-trco-addon-desc]', addon.description);
    var ai = this.$('[data-trco-addon-img]');
    if (ai && addon.image) { ai.src = addon.image; ai.alt = addon.title || ''; }
  };

  Ctrl.prototype.bindStatic = function () {
    var self = this;
    this.el.querySelectorAll('[data-trco-close]').forEach(function (elc) {
      elc.addEventListener('click', function (e) { e.preventDefault(); self.close(); });
    });
    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape' && self.el.classList.contains('is-open')) self.close();
    });

    var checkoutBtn = this.$('[data-trco-checkout]');
    if (checkoutBtn) checkoutBtn.addEventListener('click', function () { window.location.href = url('checkout'); });

    if (this.noteEl) this.noteEl.addEventListener('input', function () {
      clearTimeout(self._noteTimer);
      self._noteTimer = setTimeout(function () { postJSON('cart/update.js', { note: self.noteEl.value }); }, 600);
    });

    if (this.addonToggle) this.addonToggle.addEventListener('change', function () { self.toggleAddon(this.checked); });

    var applyBtn = this.$('[data-trco-discount-apply]');
    if (applyBtn) applyBtn.addEventListener('click', function () { self.applyDiscount(); });
    if (this.discountInput) this.discountInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); self.applyDiscount(); }
    });

    // delegated interactions
    this.el.addEventListener('click', function (e) {
      var dec = e.target.closest('[data-trco-dec]');
      var inc = e.target.closest('[data-trco-inc]');
      var rm = e.target.closest('[data-trco-remove]');
      var add = e.target.closest('[data-trco-upsell-add]');
      if (dec) self.changeLine(dec.getAttribute('data-key'), parseInt(dec.getAttribute('data-qty'), 10) - 1);
      else if (inc) self.changeLine(inc.getAttribute('data-key'), parseInt(inc.getAttribute('data-qty'), 10) + 1);
      else if (rm) self.changeLine(rm.getAttribute('data-key'), 0);
      else if (add) self.addUpsell(add);
    });
  };

  /* ---- open / close ----------------------------------------------------- */
  Ctrl.prototype.open = function () {
    if (this.el.classList.contains('is-open')) { this.startTimer(); return; }
    // Lock scroll without a layout jump: pad for the scrollbar we're about to hide.
    var sbw = window.innerWidth - document.documentElement.clientWidth;
    this.el.classList.add('is-open');
    this.el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('trco-cart-open');
    document.documentElement.style.overflow = 'hidden';
    if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
    // Force the semi-transparent backdrop to paint. It can render blank when the
    // host flips from visibility:hidden to visible; re-applying its own computed
    // background colour inline triggers the repaint. Run it after the first paint
    // (double rAF) so the nudge isn't coalesced into the initial blank frame.
    var ov = this.$('.trco-cart__overlay');
    if (ov) {
      var paint = function () { ov.style.backgroundColor = getComputedStyle(ov).backgroundColor; };
      paint();
      requestAnimationFrame(function () { requestAnimationFrame(paint); });
    }
    this.startTimer();
  };
  Ctrl.prototype.close = function () {
    this.el.classList.remove('is-open');
    this.el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('trco-cart-open');
    document.documentElement.style.overflow = '';
    document.body.style.paddingRight = '';
    this.stopTimer();
  };

  /* ---- data refresh ----------------------------------------------------- */
  Ctrl.prototype.refresh = function (openAfter) {
    var self = this;
    // Slide the drawer in immediately (shows last-known content) so it never
    // waits on the network — big perceived-speed win on mobile.
    if (openAfter) this.open();
    return getJSON('cart.js').then(function (cart) {
      self.cart = cart;
      self.render();                          // show items as soon as cart.js returns
      return self.ensureCompareData(cart);    // fetch compare-at prices off the critical path
    }).then(function () {
      self.render();                          // re-render to add the savings badges
    }).catch(function () {});
  };

  // /cart.js does not expose compare-at on line items; fetch product .js per handle.
  Ctrl.prototype.ensureCompareData = function (cart) {
    var self = this;
    var handles = {};
    (cart.items || []).forEach(function (it) { if (it.handle) handles[it.handle] = true; });
    var toFetch = Object.keys(handles).filter(function (h) { return !self.productCache[h]; });
    return Promise.all(toFetch.map(function (h) {
      return getJSON('products/' + h + '.js').then(function (p) {
        self.productCache[h] = p;
        (p.variants || []).forEach(function (v) { self.compareCache[v.id] = v.compare_at_price || null; });
      }).catch(function () { self.productCache[h] = { variants: [] }; });
    }));
  };

  // Optimistically fold the just-added line item(s) from /cart/add.js into the
  // cached cart so the drawer can render the new item INSTANTLY, without waiting
  // on a second /cart.js round-trip. refresh() then reconciles against the
  // authoritative cart (and layers on compare-at prices / upsells) a moment
  // later, so this is only ever an early, self-correcting preview.
  Ctrl.prototype.applyAddedOptimistic = function (added) {
    if (!added || !added.length) return;
    var cart = this.cart || { items: [], item_count: 0, total_price: 0, note: '' };
    var items = (cart.items || []).slice();
    added.forEach(function (ai) {
      if (!ai) return;
      var idx = -1;
      for (var i = 0; i < items.length; i++) {
        if (ai.key && items[i].key === ai.key) { idx = i; break; }
      }
      if (idx === -1) items.push(ai);   // brand-new line
      else items[idx] = ai;             // add.js quantity is the merged line total
    });
    var next = {};
    for (var k in cart) { if (cart.hasOwnProperty(k)) next[k] = cart[k]; }
    next.items = items;
    next.item_count = items.reduce(function (n, it) { return n + (it.quantity || 0); }, 0);
    next.total_price = items.reduce(function (s, it) {
      return s + (it.final_line_price != null ? it.final_line_price : (it.final_price || it.price || 0) * (it.quantity || 0));
    }, 0);
    this.cart = next;
  };

  /* ---- render ----------------------------------------------------------- */
  Ctrl.prototype.render = function () {
    var cart = this.cart;
    var copy = CONFIG.copy || {};
    var addonVariant = CONFIG.addon && CONFIG.addon.variantId;
    var self = this;

    var visible = ((cart && cart.items) || []).filter(function (it) { return it.id !== addonVariant && it.variant_id !== addonVariant; });
    var isEmpty = visible.length === 0;

    // While an add is in flight and the cart still reads empty, show a spinner
    // instead of the "empty cart" message (the drawer opened optimistically).
    if (isEmpty && this._loading) {
      this.emptyEl.hidden = true;
      this.itemsEl.hidden = false;
      this.itemsEl.innerHTML = '<div class="trco-cart__spinner" aria-label="Loading"></div>';
      this._lastItemsHTML = null;
      this.upsellsEl.hidden = true;
      this.footerEl.classList.add('is-hidden');
      this.timerEl.hidden = true;
      return;
    }
    if (!cart) return;

    this.emptyEl.hidden = !isEmpty;
    this.itemsEl.hidden = isEmpty;
    this.footerEl.classList.toggle('is-hidden', isEmpty);
    this.timerEl.hidden = isEmpty;

    if (isEmpty) {
      this.itemsEl.innerHTML = '';
      this._lastItemsHTML = null;
      this.upsellsEl.hidden = true;
      this.updateBubble(0);
      this.stopTimer();
      return;
    }

    // Only rewrite the line-items DOM when it actually changed. Re-rendering the
    // exact same markup (e.g. the background reconcile right after an optimistic
    // add) would otherwise tear down and rebuild the nodes — reloading images and
    // causing a visible flicker. Skipping identical rewrites keeps it seamless.
    var itemsHTML = visible.map(function (it) { return self.itemHTML(it); }).join('');
    if (itemsHTML !== this._lastItemsHTML) {
      this.itemsEl.innerHTML = itemsHTML;
      this._lastItemsHTML = itemsHTML;
    }
    this.updateUpsells(cart);

    var addonInCart = (cart.items || []).some(function (it) { return it.id === addonVariant || it.variant_id === addonVariant; });
    if (this.addonEl) {
      this.addonEl.hidden = !addonVariant;
      if (this.addonToggle) this.addonToggle.checked = addonInCart;
    }

    if (this.noteEl && document.activeElement !== this.noteEl) this.noteEl.value = cart.note || '';

    if (this.checkoutTextEl) {
      this.checkoutTextEl.textContent = (copy.checkout || 'Checkout') + ' • ' + formatMoney(cart.total_price);
    }

    var count = visible.reduce(function (n, it) { return n + it.quantity; }, 0);
    this.updateBubble(count);
    this.renderTimer();
  };

  Ctrl.prototype.itemHTML = function (it) {
    var copy = CONFIG.copy || {};
    var compareAt = this.compareCache[it.id];
    var priceEach = it.final_price;
    var hasCompare = compareAt && compareAt > priceEach;
    var savings = hasCompare ? (compareAt - priceEach) * it.quantity : 0;
    var img = sizedImg(it.image, 160);

    var options = (it.options_with_values || []).filter(function (o) {
      return !(o.name === 'Title' && o.value === 'Default Title');
    }).map(function (o) {
      return '<div class="trco-item__option">' + esc(o.name) + ': ' + esc(o.value) + '</div>';
    }).join('');

    var props = '';
    if (it.properties) {
      for (var k in it.properties) {
        if (!it.properties.hasOwnProperty(k)) continue;
        if (CONFIG.hideUnderscoredProperties && k.charAt(0) === '_') continue;
        if (!it.properties[k]) continue;
        props += '<div class="trco-item__option">' + esc(k) + ': ' + esc(it.properties[k]) + '</div>';
      }
    }

    var priceBlock = '<div class="trco-item__prices">' +
      (hasCompare ? '<span class="trco-item__compare">' + formatMoney(compareAt * it.quantity) + '</span>' : '') +
      '<span class="trco-item__price">' + formatMoney(priceEach * it.quantity) + '</span>' +
      (hasCompare ? '<span class="trco-item__savings">(' + esc(copy.savingsLabel || 'Save') + ' ' + formatMoney(savings) + ')</span>' : '') +
      '</div>';

    return '' +
      '<div class="trco-item" data-line-key="' + esc(it.key) + '">' +
        '<div class="trco-item__media"><a href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(it.product_title) + '" loading="lazy">' : '') + '</a></div>' +
        '<div class="trco-item__info">' +
          '<a class="trco-item__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
          options + props + priceBlock +
        '</div>' +
        '<div class="trco-item__right">' +
          '<button class="trco-item__remove" data-trco-remove data-key="' + esc(it.key) + '" aria-label="Remove">' +
            '<svg viewBox="0 0 24 24" width="16" height="16"><path d="M6 7h12M9 7V5h6v2m-8 0l1 12h8l1-12" stroke="currentColor" stroke-width="1.4" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '</button>' +
          '<div class="trco-qty">' +
            '<button data-trco-dec data-key="' + esc(it.key) + '" data-qty="' + it.quantity + '" aria-label="Decrease">−</button>' +
            '<span class="trco-qty__value">' + it.quantity + '</span>' +
            '<button data-trco-inc data-key="' + esc(it.key) + '" data-qty="' + it.quantity + '" aria-label="Increase">+</button>' +
          '</div>' +
        '</div>' +
      '</div>';
  };

  /* ---- upsells (per-product, curated) ----------------------------------- */
  // Load the product -> upsell mapping once (lazy). Shape:
  //   { "default": ["handle", ...], "byHandle": { "product-handle": ["handle", ...] } }
  Ctrl.prototype.loadUpsellMap = function () {
    if (this._upsellMap) return Promise.resolve(this._upsellMap);
    if (this._upsellMapPromise) return this._upsellMapPromise;
    var self = this;
    var u = CONFIG.upsellMapUrl;
    this._upsellMapPromise = (u ? fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.json(); }) : Promise.resolve({}))
      .then(function (m) { self._upsellMap = m || {}; return self._upsellMap; })
      .catch(function () { self._upsellMap = {}; return self._upsellMap; });
    return this._upsellMapPromise;
  };

  // Work out which upsell handles to show for the current cart:
  // each item's curated list (by handle), then the global default list,
  // de-duplicated and with anything already in the cart removed.
  Ctrl.prototype.resolveUpsells = function (cart, map) {
    var byHandle = (map && map.byHandle) || {};
    var def = (map && map.default) || CONFIG.defaultUpsells || [];
    var inCartHandles = {};
    (cart.items || []).forEach(function (it) { if (it.handle) inCartHandles[it.handle] = true; });

    var ordered = [];
    (cart.items || []).forEach(function (it) {
      var list = byHandle[it.handle];
      if (list && list.length) ordered = ordered.concat(list);
    });
    ordered = ordered.concat(def);

    var seen = {}, result = [];
    for (var i = 0; i < ordered.length; i++) {
      var h = ordered[i];
      if (!h || seen[h] || inCartHandles[h]) continue;
      seen[h] = true;
      result.push(h);
    }
    return result.slice(0, CONFIG.maxUpsells || 6);
  };

  Ctrl.prototype.ensureUpsellProducts = function (handles) {
    var self = this;
    var toFetch = handles.filter(function (h) { return self.upsellProducts[h] === undefined; });
    return Promise.all(toFetch.map(function (h) {
      return getJSON('products/' + h + '.js').then(function (p) {
        self.upsellProducts[h] = {
          id: p.id,
          handle: p.handle,
          title: p.title,
          url: '/products/' + p.handle,
          image: (p.featured_image || (p.images && p.images[0]) || ''),
          hasVariants: !p.has_only_default_variant && (p.variants || []).length > 1,
          variants: (p.variants || []).map(function (v) {
            return { id: v.id, title: v.title, price: v.price, compareAt: v.compare_at_price || null, available: v.available };
          })
        };
      }).catch(function () { self.upsellProducts[h] = null; });
    }));
  };

  Ctrl.prototype.updateUpsells = function (cart) {
    var self = this;
    this.loadUpsellMap().then(function (map) {
      var handles = self.resolveUpsells(cart, map);
      if (!handles.length) { self.upsellsEl.hidden = true; return; }
      return self.ensureUpsellProducts(handles).then(function () {
        self.renderUpsellTiles(handles);
      });
    }).catch(function () {});
  };

  Ctrl.prototype.renderUpsellTiles = function (handles) {
    var copy = CONFIG.copy || {};
    var self = this;
    var html = handles.map(function (h) {
      var u = self.upsellProducts[h];
      if (!u) return '';
      var available = u.variants.filter(function (v) { return v.available; });
      if (!available.length) return '';
      var v0 = available[0];
      var hasCompare = v0.compareAt && v0.compareAt > v0.price;

      var selector = '';
      if (u.hasVariants && u.variants.length > 1) {
        selector = '<select class="trco-upsell__select" data-trco-variant>' +
          u.variants.map(function (v) {
            return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + (v.id === v0.id ? ' selected' : '') + '>' + esc(v.title) + '</option>';
          }).join('') + '</select>';
      }

      var img = sizedImg(u.image, 120);
      return '' +
        '<div class="trco-upsell" data-product="' + u.id + '">' +
          '<div class="trco-upsell__media"><a href="' + esc(u.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(u.title) + '" loading="lazy">' : '') + '</a></div>' +
          '<div class="trco-upsell__info">' +
            '<a class="trco-upsell__title" href="' + esc(u.url) + '" title="' + esc(u.title) + '">' + esc(u.title) + '</a>' +
            '<div class="trco-upsell__prices">' +
              (hasCompare ? '<span class="trco-upsell__compare">' + formatMoney(v0.compareAt) + '</span>' : '') +
              '<span class="trco-upsell__price">' + formatMoney(v0.price) + '</span>' +
            '</div>' +
          '</div>' +
          '<div class="trco-upsell__actions">' + selector +
            '<button class="trco-upsell__add" data-trco-upsell-add data-default="' + v0.id + '">' + esc(copy.addButton || 'Add') + '</button>' +
          '</div>' +
        '</div>';
    }).join('');

    if (!html.replace(/\s/g, '')) { this.upsellsEl.hidden = true; return; }
    if (html !== this._lastUpsellHTML) {
      this.upsellListEl.innerHTML = html;
      this._lastUpsellHTML = html;
    }
    this.upsellsEl.hidden = false;
  };

  Ctrl.prototype.addUpsell = function (btn) {
    var wrap = btn.closest('.trco-upsell');
    var select = wrap ? wrap.querySelector('[data-trco-variant]') : null;
    var variantId = select ? parseInt(select.value, 10) : parseInt(btn.getAttribute('data-default'), 10);
    if (!variantId) return;
    var self = this;
    btn.disabled = true;
    this.el.classList.add('is-busy');
    postJSON('cart/add.js', { items: [{ id: variantId, quantity: 1 }] })
      .then(function () { return self.refresh(false); })
      .then(function () { self.el.classList.remove('is-busy'); })
      .catch(function () { self.el.classList.remove('is-busy'); btn.disabled = false; });
  };

  /* ---- line changes ----------------------------------------------------- */
  Ctrl.prototype.changeLine = function (key, quantity) {
    if (!key) return;
    var self = this;
    this.el.classList.add('is-busy');
    postJSON('cart/change.js', { id: key, quantity: Math.max(0, quantity) })
      .then(function (cart) { self.cart = cart; return self.ensureCompareData(cart); })
      .then(function () { self.render(); self.el.classList.remove('is-busy'); })
      .catch(function () { self.el.classList.remove('is-busy'); });
  };

  /* ---- add-on ----------------------------------------------------------- */
  Ctrl.prototype.toggleAddon = function (on) {
    var variantId = CONFIG.addon && CONFIG.addon.variantId;
    if (!variantId) return;
    var self = this;
    this.el.classList.add('is-busy');
    var p;
    if (on) {
      p = postJSON('cart/add.js', { items: [{ id: variantId, quantity: 1 }] });
    } else {
      var line = (this.cart.items || []).filter(function (it) { return it.id === variantId || it.variant_id === variantId; })[0];
      p = line ? postJSON('cart/change.js', { id: line.key, quantity: 0 }) : Promise.resolve();
    }
    p.then(function () { return self.refresh(false); })
      .then(function () { self.el.classList.remove('is-busy'); })
      .catch(function () { self.el.classList.remove('is-busy'); });
  };

  /* ---- discount --------------------------------------------------------- */
  Ctrl.prototype.applyDiscount = function () {
    var code = (this.discountInput.value || '').trim();
    if (!code) return;
    var self = this;
    var copy = CONFIG.copy || {};
    fetch(url('discount/' + encodeURIComponent(code)), { credentials: 'same-origin' })
      .catch(function () {})
      .then(function () {
        self.discountStatus.hidden = false;
        self.discountStatus.innerHTML = '✓ ' + esc(code) + ' — ' + esc(copy.discountAppliedAtCheckout || 'Applied at checkout') +
          ' <button type="button" data-trco-clear-discount>Remove</button>';
        var clr = self.discountStatus.querySelector('[data-trco-clear-discount]');
        if (clr) clr.addEventListener('click', function () {
          self.discountStatus.hidden = true;
          self.discountInput.value = '';
          fetch(url('discount/'), { credentials: 'same-origin' }).catch(function () {});
        });
      });
  };

  /* ---- cart bubble ------------------------------------------------------ */
  Ctrl.prototype.updateBubble = function (count) {
    var wrap = document.querySelector('.cart-count-bubble');
    if (wrap) {
      var span = wrap.querySelector('span[aria-hidden="true"]') || wrap.querySelector('span');
      if (span) span.textContent = count;
      wrap.style.display = count > 0 ? '' : 'none';
      return;
    }
    // Bubble not yet in DOM (e.g. first item added) — build it via Dawn's section render.
    var icon = document.getElementById('cart-icon-bubble');
    if (count > 0 && icon) {
      fetch(url('?section_id=cart-icon-bubble'), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          try {
            var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('cart-icon-bubble');
            if (fresh) icon.innerHTML = fresh.innerHTML;
          } catch (e) {}
        }).catch(function () {});
    }
  };

  /* ---- timer ------------------------------------------------------------ */
  Ctrl.prototype.timerEnd = function () {
    var minutes = CONFIG.timerMinutes || 10;
    var now = Date.now();
    var end = 0;
    try { end = parseInt(localStorage.getItem('trco_timer_end'), 10) || 0; } catch (e) {}
    if (!end || end <= now) {
      end = now + minutes * 60000;
      try { localStorage.setItem('trco_timer_end', String(end)); } catch (e) {}
    }
    return end;
  };
  Ctrl.prototype.renderTimer = function () {
    if (!this.timerTextEl) return;
    var remaining = Math.max(0, this.timerEnd() - Date.now());
    if (remaining <= 0) {
      try { localStorage.removeItem('trco_timer_end'); } catch (e) {}
      remaining = Math.max(0, this.timerEnd() - Date.now());
    }
    var total = Math.floor(remaining / 1000);
    var tmpl = (CONFIG.copy && CONFIG.copy.timer) || 'Your products are reserved for {time} minutes!';
    this.timerTextEl.textContent = tmpl.replace('{time}', pad(Math.floor(total / 60)) + ':' + pad(total % 60));
  };
  Ctrl.prototype.startTimer = function () {
    var self = this;
    this.renderTimer();
    this.stopTimer();
    this.timerInterval = setInterval(function () { self.renderTimer(); }, 1000);
  };
  Ctrl.prototype.stopTimer = function () {
    if (this.timerInterval) { clearInterval(this.timerInterval); this.timerInterval = null; }
  };

  /* ==========================================================================
     Boot + global interception
     ========================================================================== */
  var controller = null;
  function boot() {
    var el = document.getElementById('TrcoCart');
    if (el && !controller) controller = new Ctrl(el);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // open on cart icon click
  var selectors = (CONFIG.cartIconSelectors || []).join(',');
  document.addEventListener('click', function (e) {
    if (!selectors || !controller) return;
    var trigger = e.target.closest(selectors);
    if (!trigger || trigger.closest('trco-cart')) return;
    e.preventDefault();
    controller.refresh(true);
  }, true);

  // close when clicking anywhere outside the drawer panel
  document.addEventListener('click', function (e) {
    if (!controller || !controller.el.classList.contains('is-open')) return;
    if (e.target.closest('.trco-cart__panel')) return;      // click inside the drawer
    if (selectors && e.target.closest(selectors)) return;   // cart icon is handled above
    e.preventDefault();
    e.stopPropagation();
    controller.close();
  }, true);

  // intercept add-to-cart form submissions
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    if (!CONFIG.openOnAddToCart || !controller) return;

    e.preventDefault();
    e.stopPropagation();

    // Open the drawer instantly (don't wait on the network); show a spinner until
    // the item lands, then fill in the real contents.
    controller._loading = true;
    controller.open();
    controller.render();

    var fd = new FormData(form);
    fd.delete('sections');
    fd.delete('sections_url');
    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.setAttribute('aria-busy', 'true');

    fetch(url('cart/add.js'), { method: 'POST', headers: { 'Accept': 'application/json' }, credentials: 'same-origin', body: fd })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (submitBtn) submitBtn.removeAttribute('aria-busy');
        controller._loading = false;
        if (res && res.status && res.status >= 400) { controller.render(); return; } // sold out / error
        // Render the added item IMMEDIATELY from the add response (no wait for
        // cart.js). refresh() below reconciles the authoritative cart, compare-at
        // prices and upsells a moment later.
        try {
          var added = res && res.items ? res.items : (res && (res.key || res.id) ? [res] : []);
          if (added.length) { controller.applyAddedOptimistic(added); controller.render(); }
        } catch (err) {}
        controller.refresh(false);   // drawer already open; reconcile its contents
      })
      .catch(function () {
        if (submitBtn) submitBtn.removeAttribute('aria-busy');
        controller._loading = false;
        controller.refresh(false);
      });
  }, true);

  // Robustly open on ANY successful add-to-cart, however it is triggered — a
  // normal form submit, theme JS, or a third-party app (e.g. back-in-stock)
  // that intercepts the request before the form's submit event fires.
  function isAddUrl(u) { return typeof u === 'string' && u.indexOf('/cart/add') !== -1; }

  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function () {
      var a0 = arguments[0];
      var reqUrl = (a0 && a0.url) ? a0.url : a0;
      var p = origFetch.apply(this, arguments);
      if (isAddUrl(reqUrl) && CONFIG.openOnAddToCart) {
        p.then(function (res) {
          // Only auto-open when the drawer is closed and we're not already driving
          // it (our own upsell/add-on adds refresh the open drawer themselves).
          if (res && res.ok && controller && !controller._loading && !controller.el.classList.contains('is-open')) controller.refresh(true);
        }).catch(function () {});
      }
      return p;
    };
  }

  var XHR = window.XMLHttpRequest;
  if (XHR && XHR.prototype) {
    var origOpen = XHR.prototype.open;
    var origSend = XHR.prototype.send;
    XHR.prototype.open = function (method, u) { this.__trcoAdd = isAddUrl(u); return origOpen.apply(this, arguments); };
    XHR.prototype.send = function () {
      var xhr = this;
      if (xhr.__trcoAdd && CONFIG.openOnAddToCart) {
        xhr.addEventListener('load', function () {
          if (xhr.status >= 200 && xhr.status < 300 && controller && !controller._loading && !controller.el.classList.contains('is-open')) controller.refresh(true);
        });
      }
      return origSend.apply(this, arguments);
    };
  }

  window.TrcoCart = {
    open: function () { if (controller) controller.refresh(true); },
    close: function () { if (controller) controller.close(); },
    refresh: function () { if (controller) controller.refresh(false); }
  };
})();
